const TypingIndicator = () => {
  return (
    <div className='typing-container'>
      <div className="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className='typing-badge'>Typing...</div>
    </div>
  );
};

export default TypingIndicator;